import React, { Component } from 'react';
import { observer } from 'mobx-react';

import {
  Wrapper,
  Header,
  Progress,
  Title,
  Caption,
  CloseButton,
  Nav,
  NavButton,
} from './style';

import AppState from '../../states/AppState';
import IntroCloudState from '../../states/IntroCloudState';

class IntroSlideshow extends Component {
  componentDidMount() {
    window.addEventListener('keyup', this._handleKeyUp);
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this._handleKeyUp);
  }

  _handleKeyUp = (evt) => {
    const { activeItem } = IntroCloudState;

    switch(evt.keyCode) {
      case 39:
        IntroCloudState.activateItem(activeItem.nextItemIndex);
        break;
      
      case 37:
        IntroCloudState.activateItem(activeItem.prevItemIndex);
        break;

      case 27:
        IntroCloudState.deactivateItem();
        break;
    }
  }

  render() {
    const { activeItem } = IntroCloudState;

    return (
      <Wrapper active={activeItem ? true : false}>
        {activeItem && (
          <Header>
            <Progress>
              {activeItem.itemIndex + 1}/{activeItem.listItemsCount}
            </Progress>
            <Title>
              {activeItem.listTitle}
            </Title>
            <CloseButton
              onClick={evt => {
                evt.preventDefault();
                IntroCloudState.deactivateItem();
              }}
            >Close</CloseButton>
          </Header>
        )}
        {activeItem && (
          <Caption>
            {activeItem.listTitleMain} – {activeItem.caption}
          </Caption>
        )}
        {activeItem && (
          <Nav>
            {!AppState.touch && activeItem.prevItemIndex !== null && (
              <NavButton
                prev
                onClick={evt => {
                  evt.preventDefault();
                  IntroCloudState.activateItem(activeItem.prevItemIndex);
                }}
              />
            )}
            <NavButton
              close
              onClick={evt => {
                evt.preventDefault();
                IntroCloudState.deactivateItem();
              }}
            />
            {!AppState.touch && activeItem.nextItemIndex !== null && (
              <NavButton
                next
                onClick={evt => {
                  evt.preventDefault();
                  IntroCloudState.activateItem(activeItem.nextItemIndex);
                }}
              />
            )}
          </Nav>
        )}
      </Wrapper>
    );
  }
}

export default observer(IntroSlideshow);



// WEBPACK FOOTER //
// ./src/components/IntroSlideshow/index.js